import React, { useState } from "react";
import "./CollageGallery.css";
import { useNavigate } from "react-router-dom";
import { title } from "framer-motion/client";

const galleryItems = [
  { src: "/ourproducts/sda/1.jpg", title: "SDA Residence", description: "A bespoke residence designed for Mr. Prem Singh Rana.", rowSpan: 5, colSpan: 2, slug: 'homes4', },
    { src: "/ourproducts/onedxpp/1.jfif", title: "One DXP Experience Center", description: "Grand multi-level sales gallery experience.", rowSpan: 3, colSpan: 2, slug: 'exp', },

  // { src: "/ourproducts/sda/3.jpg", title: "SDA Residence", description: "A bespoke residence designed for Mr. Prem Singh Rana.", rowSpan: 5, colSpan: 1, slug: 'homes4' },

  // Text block example
  { type: "text", content: "Explore our diverse projects and bespoke design solutions.", rowSpan: 2, colSpan: 1,  },
    {  src: "/ourproducts/M3M/M3M.png",  title: "M3M Sales Gallery", description: "4 BHK Sample Apartment with bespoke interior and FF&E design detailing and execution", slug: 'sample2', rowSpan: 2, colSpan: 1 },

  { src: "/ourproducts/BloombergQuint/BloombergQuint/1.jfif", title: "Bloomberg Quint", description: 'New floor for Bloomberg Quint in Mumbai with studios, post production facilities and youthful interiors', slug: 'offices8', rowSpan: 3, colSpan: 2 },

  { src: "/ourproducts/ASF/ASF/ASF.jpg", title: "ASF Experience Centre", description: 'Sales experience center for ASF in Gurgaon', rowSpan: 2, colSpan: 2, slug: 'exp5' },
    { type: "text", content: "Precision-crafted sample apartments that speak before words do.", rowSpan: 2, colSpan: 1 },



{ src: "/ourproducts/nfc.jpg", title: "NFC Residence", description: "Bespoke residence for Mrs. Bagheria.", slug: "homes2", rowSpan: 3, colSpan: 1 },  


{ src: "/ourproducts/InterOcean/InterOcean/1.jfif", title: "InterOcean", description: "New office for InterOcean in Gurgaon with collaborative workspaces, training rooms and vibrant interiors", rowSpan: 4, colSpan: 2, slug: "offices5" },  



{ src: "/ourproducts/Trevoc/Trevoc/Trevoc.png", title: "Trevoc Sales Gallery", description: "Proposed Sales Gallery in Gurgaon", rowSpan: 3, colSpan: 1, slug: "exp3" },
    { type: "text", content: "Sales galleries designed to inspire confidence and close deals.", rowSpan: 2, colSpan: 1 },

  // Another text block
  { type: "text", content: "Offices that reflect ambition, culture and the way you work.", rowSpan: 2, colSpan: 2 },
{ src: "/ourproducts/smartworldsample/smartworld.png", title: "SmartWorld Sample Apartment", description: "4 BHK Sample Apartment with stunning interior and FF&E design detailing and execution.", rowSpan: 2, colSpan: 2, slug: "Sample1" },

    { src: "/ourproducts/Filatex/fila.png", title: "Filatex Corporate Office", description: 'Elegance, understated luxury and functionality defined the design and build of this new corporate office for Filatex', rowSpan: 4, colSpan: 3,slug: 'offices1', },
  { src: "/ourproducts/Trevoc/Trevoc/Trevoc2.png", title: "Trevoc Sales Gallery", rowSpan: 4, colSpan: 1,   slug: 'Sample1',  description: "Proposed Sales Gallery in Gurgaon",slug: "exp3" },
  // { src: "/ourproducts/BloombergQuint/BloombergQuint/1.jfif",  title: "Bloomberg Quint", description: 'New floor for Bloomberg Quint in Mumbai with studios, post production facilities and youthful interiors', slug: 'offices8', rowSpan: 4, colSpan: 1 },

  { src: "/ourproducts/AUrealestate/au.png", title: "AU Real Estate", description: "Elegant new sales gallery.", rowSpan: 2, colSpan: 2,  slug: 'exp2'},
  
{ src: "/ourproducts/IFlyIndigo/Indigo.png", title: "IFLY | Indigo", rowSpan: 2, colSpan: 2, slug: "offices6", description: "New and state of the art training facility for Indigo Airlines with stunning interiors" }, 
  { type: "text", content: "Residences crafted with detail, warmth and a sense of home.", rowSpan: 2, colSpan: 1 },

  { src: "/ourproducts/UpGrad/UpGrad/1.jfif", title: "Upgrad Office", rowSpan: 2, colSpan: 2, slug: 'offices2', description: 'New office for UpGrad in Noida with collaborative workspaces, training rooms and vibrant interiors' },
   { type: "text", content: "Explore our diverse projects and bespoke design solutions.", rowSpan: 2, colSpan: 1 },


// { src: "/ourproducts/QuikrCampus/QuikrCampus/1.png", title: "Quickr Campus", rowSpan: 3, colSpan: 1, slug: "offices7", description: "Redevelopment of an old factory with amazing ceiling heights into the new corporate headquarters for Quikr." },  
  // { src: "/ourproducts/InterOcean/InterOcean/1.jfif", title: "InterOcean", rowSpan: 3, colSpan: 2, slug: 'offices5', description: 'New office for InterOcean in Gurgaon with collaborative workspaces, training rooms and vibrant interiors' },
    
// { src: "/ourproducts/ThQuint/1.jfif", title: "The Quint", description: "Young, dynamic, eclectic interiors for The Quint in Noida", slug: "offices9", rowSpan: 3, colSpan: 1 }
];

function CollageGallery() {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);

  const openPopup = (item) => {
    setSelectedItem(item);
  };

  const closePopup = () => {
    setSelectedItem(null);
  };

  return (
    <section className="collage-section">
      <div className="collage-grid">
        {galleryItems.map((item, idx) => {
          if (item.type === "text") {
            return (
              <div
                key={idx}
                className="masonry-item text-block"
                style={{
                  gridRowEnd: `span ${item.rowSpan}`,
                  gridColumnEnd: `span ${item.colSpan}`,
                }}
              >
                <p>{item.content}</p>
              </div>
            );
          }

         return (
  <div
    key={idx}
    className="masonry-item"
    style={{
      gridRowEnd: `span ${item.rowSpan}`,
      gridColumnEnd: `span ${item.colSpan}`,
    }}
    onClick={() => openPopup(item)}
  >
    {/* IMAGE */}
    <img
      src={item.src}
      alt={item.title || `Gallery image ${idx}`}
      className="masonry-img"
    />

    {/* ADD THIS HERE ↓↓↓ */}
    <div className="masonry-overlay">
      {item.title && <h3>{item.title}</h3>}
      {item.description && <p>{item.description}</p>}

      {item.slug && (
        <button
          className="view-project-btn"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/products/${item.slug}`);
          }}
        >
          View Project
        </button>
      )}
    </div>
    {/* ADD THIS HERE ↑↑↑ */}

  </div>
);
        })}
      </div>

      {/* Popup Modal */}
      {selectedItem && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={closePopup}>
              ×
            </button>

            <img
              src={selectedItem.src}
              alt={selectedItem.title}
              className="popup-image"
            />

            <div className="popup-details">
              {selectedItem.title && <h2>{selectedItem.title}</h2>}
              {selectedItem.description && (
                <p>{selectedItem.description}</p>
              )}

              {selectedItem.slug && (
                <button
                  className="view-project-btn"
                  onClick={() =>
                    navigate(`/products/${selectedItem.slug}`)
                  }
                >
                  View Project
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default CollageGallery;